/**
 * Marital Status Mapper
 * Maps transport layer DTOs to domain models
 */

import type { LC_GetMaritalStatusOut, MaritalStatus } from './maritalStatus.types';

/**
 * Maps marital statuses response from backend to UI domain model
 * Backend sends array directly in envelope.data
 */
export const mapMaritalStatuses = (out: LC_GetMaritalStatusOut): MaritalStatus[] => {
  if (!out) return [];
  return out.map((status) => ({ 
    id: status.id, 
    description: status.description, 
  }));
};
